import { render, staticRenderFns } from "./PanelInputSwitchMini.vue?vue&type=template&id=140bd224&scoped=true&"
import script from "./PanelInputSwitchMini.vue?vue&type=script&lang=js&"
export * from "./PanelInputSwitchMini.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputSwitchMini.vue?vue&type=style&index=0&id=140bd224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bd224",
  null
  
)

export default component.exports